import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Financeur from '../Entity/Financeur'

/**
* Class FinanceurList
* FinanceurList view component
**/
class FinanceurList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Financeur;

    // Filter list
    const filters = [{
      title: "Nom du financeur",
      type: "text",
      name: "libelleFinanceur",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes financeurs</h2>
        <GridFilter title="Filtrer les financeurs" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Financeurs" ref={"grid" + objectClass.name} path="financeurs" objectPath="financeurs" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + Financeur.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + Financeur.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + Financeur.name];
    grid.clearFilters();
  }

}
export default FinanceurList;



// WEBPACK FOOTER //
// ./src/views/Search/FinanceurList.js